import { queryData } from '@/domains/core/graphqlClient/queryClient';
import { HttpHeaders } from '@/domains/core/httpClient/httpHeaders';
import { type CartOverview } from '@/domains/shoppingCart/CartOverview/interfaces/CartOverview';
import {
  ComputeCartTotalInput,
  Market,
  Platform,
} from '@/generated/graphql/types';

import {
  GetCustomerCartOverviewDocument,
  GetCustomerCartOverviewQuery,
} from './graphql/generated/cartOverviewQuery.generated';
import { formatForCartOverview } from './utils/formatForCartOverview';

export const GET_MSF_CART_OVERVIEW_URL = `/web/api/v1/cart-module/overview`;

export type GetCartOverviewProps = {
  customerId: number;
  platform: Platform;
  market: Market;
  request: ComputeCartTotalInput;
};

export const getCustomerCartOverview = async ({
  customerId,
  platform,
  market,
  request,
}: GetCartOverviewProps): Promise<CartOverview> => {
  const response = await queryData<GetCustomerCartOverviewQuery>(
    GetCustomerCartOverviewDocument,
    { customerId, platform, market, request },
    {
      [HttpHeaders.X_MM_PLATFORM]: platform,
    },
  );

  return formatForCartOverview(response);
};
